import React, { useEffect, useRef, useState } from "react"
import "./TabbingModule.css"
import * as styles from "./TabbingModule-tw-styles"
import PropTypes from "prop-types"
import Image from "../UI/Image/Image"
import { get } from "../../helpers/utils"
import ImageWithText from "../ImageWithText/ImageWithText"
import useScreenSize from "../../hooks/useScreenSize"
import MultiColumnGridWithTextOrLink from "../MultiColumnGridWithTextOrLink/MultiColumnGridWithTextOrLink"
import ImageCardsLayout from "../ImageCardsLayout/ImageCardsLayout"
import Typography from "../UI/Typography/Typography"
import TabsContainerWrapper from "../TabsContainerWrapper/TabsContainerWrapper"

function Tabbing(props) {
  const {
    title,
    tabbingWrapperCollection,
    variant,
    tabsVariant,
    uniqueId,
    titleColor,
  } = props
  const [visibleTab, setVisibleTab] = useState("")
  const [isActive, setActive] = useState(false)
  const style = styles[variant] || styles.defaultStyle
  const screen = useScreenSize()
  const ElementEL = useRef()
  const tabbingWraper = get(tabbingWrapperCollection, "items", [])
  let uniqId = uniqueId == "ECTeamTabbingModule2" ? "Tabbing2" : "Tabbing1"

  useEffect(() => {
    let element1 = ""
    let element2 = ""
    let element3 = ""
    if (uniqId == "Tabbing2") {
      element1 = document.getElementById(`Tabbing1`)
      element2 = document.getElementById(`parentTabbing1`)
      element3 = document.getElementsByClassName(
        `${style?.tabbingImageGroup} Tabbing1`
      )
    }
    if (uniqId == "Tabbing1") {
      element1 = document.getElementById(`Tabbing2`)
      element2 = document.getElementById(`parentTabbing2`)
      element3 = document.getElementsByClassName(
        `${style?.tabbingImageGroup} Tabbing2`
      )
    }
    if (element1 && element2 && element3?.length > 0) {
      element2.style.height = "0px"
      element1.style.maxHeight = "0px"
      element3[0].className = "tabbingImageGroup"
    }
  })

  function toggleClass(e, idx) {
    if (visibleTab === e) {
      setActive(false)
      setVisibleTab(null)
    } else {
      setActive(true)
      setVisibleTab(e)
    }
  }
  const handleChildClass = e => {
    e.stopPropagation()
  }

  const getListHeight = idx => {
    for (let element of document.getElementsByClassName(
      `tabiingCl${idx}${uniqId}`
    )) {
      const newHeight2 = element.scrollHeight
      return newHeight2
    }
  }
  const listTitles = tabbingWraper?.map((item, idx) => (
    <li
      data-testid={idx}
      id="tabClick"
      key={idx}
      onClick={() => {
        toggleClass(item?.elementid, idx)
      }}
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          toggleClass(item?.elementid, idx)
        }
      }}
      className={
        visibleTab === item?.elementid
          ? `${style?.tabbingImageList} active`
          : style?.tabbingImageList
      }
      aria-expanded={
        visibleTab === item?.elementid
          ? "true"
          : "false"
      }
      aria-label={item?.title}
      role="button"
      tabIndex={0}
    >
      <div className={style?.tabbingImageListInner}>
        <div className={style?.tabbingImageListSection}>
          <div className={style?.tabbingImageWrapper}>
            <Image
              contentfulImage={item?.image?.imageDesktop}
              className={style?.tabbingImage}
              alt={item?.image?.altText}
            />
          </div>

          <div className={style?.tabbingImageOverlay}>
            <div className={style?.tabbingImageOverlaySection}>
              <p
                className={style?.tabbingImageOverlayP}
                dangerouslySetInnerHTML={{ __html: item?.title }}
              ></p>
            </div>
          </div>
        </div>
      </div>
      {
        <div
          data-testid={item?.imageWithText?.heading}
          key={idx}
          id={
            item?.elementid && visibleTab === item?.elementid
              ? `parent${uniqId}`
              : ""
          }
          className={
            visibleTab === item?.elementid && isActive
              ? `${style?.tabbingImageListWrapper}`
              : style?.tabbingHide
          }
          style={{
            //height should be 0
            height:
              item?.elementid && visibleTab === item?.elementid
                ? getListHeight(idx)
                : 0,
          }}
        >
          <div
            ref={ElementEL}
            id={
              item?.elementid && visibleTab === item?.elementid
                ? `${uniqId}`
                : ""
            }
            className={
              item?.contentImage
                ? `${style?.tabbingImageListContainer} tabiingCl${idx}${uniqId}`
                : `${style?.tabbingImageListContainerFull} tabiingCl${idx}${uniqId}`
            }
            style={{
              // should be 0
              maxHeight:
                item?.elementid && visibleTab === item?.elementid
                  ? getListHeight(idx)
                  : 0,
              position: "absolute",
              left: "0",
            }}
            onClick={e => {
              handleChildClass(e)
            }}
          >
            {
              <div className={style?.tabbingImageListContainerInner}>
                <div className={style?.tabbingImageListContainerP}>
                  {
                    <div>
                      <div>
                        {item?.imageWithText !== null && (
                          <div>
                            <ImageWithText
                              {...item?.imageWithText}
                            ></ImageWithText>
                          </div>
                        )}
                      </div>
                      {item?.multicolumnCollection.items.length > 0 && (
                        <div>
                          {item?.title && (
                            <Typography
                              className={style?.marketingTitle}
                              content={item?.title}
                            ></Typography>
                          )}
                          {item?.description && (
                            <Typography
                              className={style?.marketingDesc}
                              content={item?.description}
                            ></Typography>
                          )}
                          <MultiColumnGridWithTextOrLink
                            {...item?.multicolumnCollection}
                            variant={item.variant}
                          />
                        </div>
                      )}
                      {item?.imageCardLayout !== null && (
                        <div>
                          <ImageCardsLayout {...item?.imageCardLayout} />
                        </div>
                      )}
                    </div>
                  }
                </div>
              </div>
            }
          </div>
        </div>
      }
    </li>
  ))

  return (
    <>
      {!tabsVariant ? (
        <div className={style?.tabbingImageFullContainer}>
          <div className={style?.tabbingImageContainer}>
            <div
              className={
                isActive
                  ? `${style?.tabbingImageGroup} ${uniqId}`
                  : "tabbingImageGroup"
              }
            >
              {title && (
                <h2
                  className={
                    titleColor
                      ? style?.["title" + titleColor]
                      : style?.titlePurple
                  }
                >
                  {title}
                </h2>
              )}
              {listTitles && (
                <ul className={style?.tabbingImageUL}>{listTitles}</ul>
              )}
            </div>
          </div>
        </div>
      ) : (
        <TabsContainerWrapper {...props} />
      )}
    </>
  )
}
Tabbing.propTypes = {
  tabbingWrapperCollection: PropTypes.object,
  variant: PropTypes.string,
  title: PropTypes.string,
  tabsVariant: PropTypes.bool,
  linkContent: PropTypes.object,
  brandTabs: PropTypes.bool,
  uniqueId: PropTypes.string,
  titleColor: PropTypes.string,
}

export default Tabbing